<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field slot="pi_date" :label="'交货日期'" v-model="form.main.pi_date"/>
        <department-field slot="pi_departmentname" :label="customLabel.pi_departmentname || '部门'" v-model="form.main.pi_departmentname" @select="onSelectDepartment" />
        <custom-field 
          :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" :caller="caller" fieldName="pi_text1"
          slot="pi_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" :caller="caller" fieldName="pi_text2"
          slot="pi_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" :caller="caller" fieldName="pi_text3"
          slot="pi_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" :caller="caller" fieldName="pi_text4"
          slot="pi_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" :caller="caller" fieldName="pi_text5"
          slot="pi_text5" hidden="true"
        />
      </custom-layout>

      <div class="weui-cells__group" v-for="(item,xindex) in form.items" :key="xindex">
        <div class="weui-cells__title">
          <span>产品{{xindex+1}}</span>
          <a href="javascript:;" class="header-tool" @click="removeItem(xindex)">
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
        <custom-layout :view-config="customViewConfig" position="detail1">
          <product-field slot="pr_code" :label="customLabel.pr_code || '物料编号'"
            v-model="item.productDTO.pr_code"
            @select="onItemSelectProduct($event, item)"
          />
          <div class="weui-cell" v-if="item.productDTO.pr_detail" slot="pr_detail">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pr_detail || "物料名称"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.productDTO.pr_detail}}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pr_orispeccode || "型号"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.productDTO.pr_orispeccode}}</div>
          </div>
          <div class="weui-cell" slot="pd_inqty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_outqty || "数量"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_outqty"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{item.productDTO.pr_unit}}</div>
          </div>
          <warehouse-field :label="'调出仓库'" v-model="item.pd_whname" @select="onItemSelectOutWarehouse($event, item)" />
          <warehouse-field :label="'调入仓库'" v-model="item.pd_inwhname" @select="onItemSelectInWarehouse($event, item)" />
          <div class="weui-cell" v-if="item.pd_batchcode" slot="pd_batchcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_batchcode || "批次号"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.pd_batchcode}}</div>
          </div>
          <div class="weui-cell" slot="pd_price">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_price || "成本单价(元)"}}</label>
            </div>
            <div class="weui-cell__bd">{{ item.pd_price }}</div>
          </div>
          <div class="weui-cell" slot="pd_total">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_total || "成本金额(元)"}}</label>
            </div>
            <div class="weui-cell__bd">{{numberFormat(item.pd_total,'¥#,##0.00')}}</div>
          </div>
          <div class="weui-cell" slot="pd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_remark || "备注"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.pd_remark"
                placeholder="请填写"
              />
            </div>
          </div>
          <custom-field 
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" :caller="caller" fieldName="pd_text1"
            slot="pd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" :caller="caller" fieldName="pd_text2"
            slot="pd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" :caller="caller" fieldName="pd_text3"
            slot="pd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" :caller="caller" fieldName="pd_text4"
            slot="pd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" :caller="caller" fieldName="pd_text5"
            slot="pd_text5" hidden="true"
          />
        </custom-layout>
          <a
            href="javascript:"
            v-if="xindex==form.items.length-1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import ProductField from "@/components/field/ProductField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    DateField,
    DepartmentField,
    ProductField,
    WarehouseField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "AppropriationInOut",
      xtype: "stock-appropriationinout-formpanel",
      form: {
        main: {
          pi_class: "MOVEOUT"
        },
        items: [
          {
            productDTO: {}
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 选择部门
     */
    onSelectDepartment(selection) {
      var main = this.form.main;
      main.pi_departmentcode = selection.dp_code;
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    /**
     * 选择调出仓库
     */
     onItemSelectOutWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 选择调入仓库
     */
     onItemSelectInWarehouse(selection, item) {
      item.pd_inwhid = selection.id;
      item.pd_inwhcode = selection.wh_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      var count = 0;
      if(!main.pi_date) {
        me.$weui.topTips(`日期未选择`, 2000);
        return
      } else if (!main.pi_departmentname) {
        me.$weui.topTips(`部门未选择`, 2000);
        return
      }
      items.forEach(function(item) {
        if (!item.pd_prodid) {
          me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
          return false;
        } else if (!item.pd_whid) {
          me.$weui.topTips(`第${count + 1}行调出仓库未选择`, 2000);
          return false;
        } else if (!item.pd_inwhid) {
          me.$weui.topTips(`第${count + 1}行调入仓库未选择`, 2000);
          return false;
        } else if (!item.pd_outqty || item.pd_outqty <= 0) {
          me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
          return false;
        } else {
          count++;
          item.pd_pdno = count;
        }
      });
      checked = count == items.length;

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pd_inwhcode: "",
        pd_inwhid: null,
        pd_inwhname: "",
        pd_outqty: 0,
        pd_pdno: 1,
        pd_prodcode: "",
        pd_prodid: null,
        pd_remark: "",
        pd_whcode: "",
        pd_whid: null,
        pd_whname: "",
        productDTO: {}
      });
    }
  }
};
</script>